module.exports = __webpack_public_path__ + "assets/img/jiagou3.edfde4d9.svg";